import React from 'react';
import { DialogUI } from '../Interface';
import SourceListPage from './SourceListPage';

const SourceListDialog = ({ showDialog, onClose, selectedItemCode }) => {
  return (
    <DialogUI
      open={showDialog}
      headerContent={'Forrásjegyzék'}
      fullWidth={true}
      onClose={onClose}
      closeBtn={true}
      maxWidth="xl"
    >
      <SourceListPage selectedItemCode={selectedItemCode} />
    </DialogUI>
  );
};

export default SourceListDialog;
